import { CommonModule } from '@angular/common';
import { Component, Input, ViewEncapsulation } from '@angular/core';
import { ConfirmDialogModule } from 'primeng/confirmdialog';

@Component({
	selector: 'app-confirm-dialog',
	imports: [CommonModule, ConfirmDialogModule],
	templateUrl: './confirm-dialog.component.html',
	styleUrl: './confirm-dialog.component.scss',
	encapsulation: ViewEncapsulation.None,
})
export class ConfirmDialogComponent {
	@Input() key?: string; // Allows multiple confirm dialogs with different configurations
}
